import { regularReq, loginReq } from "@/utils/request";
export function getVerCode(data) {
  return regularReq({
    url: "/rest/ums/api/dynamic-pwd/get",
    method: "post",
    data
  });
}
export function login(data) {
  return loginReq({
    url: "/rest/auth/api/oauth/token?grant_type=roki",
    method: "get",
    //headers:{"Content-Type": "multipart/form-data"},
    params: data
  });
}
export function getUserInfo(token) {
  return regularReq({
    url: "/rest/ums/api/user/get/oauth",
    method: "get",
    headers: { Authorization: token }
    // params
  });
}
//access_token过期，重新刷新token
export function reFreshAccessTokenFun(data) {
  return loginReq({
    url: "/rest/auth/api/oauth/token?grant_type=refresh_token",
    method: "get",
    //headers:{"Content-Type": "multipart/form-data"},
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/WebLoginRoki.js